import { UseCase } from "@/(global)/contact/components/types";
import type { Locale } from "@/config/i18n";
import { tr } from "@/config/localeText";
import { CONTACT_UI } from "@/(global)/contact/components/contactDict";

/**
 * Types de demande localisés. Les `id` restent stables (enum API) ; seuls les
 * libellés d'affichage changent selon la locale. Source : CONTACT_UI[locale].
 */
export const getUseCases = (locale: Locale = "fr"): UseCase[] =>
  tr(CONTACT_UI, locale).useCases.map((uc) => ({
    id: uc.id,
    label: uc.label,
    subtitle: uc.subtitle,
    subject: uc.subject,
  }));

/**
 * Export FR conservé tel quel (sortie identique) pour les consommateurs
 * existants — notamment `app/api/contact/route.tsx`.
 */
export const useCases: UseCase[] = getUseCases("fr");
